import { generateOneLinkUrl } from '@cian/appsflyer-onelink';
import * as React from 'react';

import { useRuntimeSetting } from '../hooks/useRuntimeSetting';

export const useDownloadNativeAppUrl = (campaignTitle?: string) => {
  const downLoadUrl = useRuntimeSetting<string>('mobileBanner.browserUrl', '');

  const [downloadNativeAppUrl, setDownloadNativeAppUrl] = React.useState('');

  React.useEffect(() => {
    const url = generateOneLinkUrl(downLoadUrl, 'mobile_site', campaignTitle) || '';
    setDownloadNativeAppUrl(url);
  }, []);

  return downloadNativeAppUrl;
};
